export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-it-e5ac597d.png'